import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <div>
      {/* Footer Start */}
      <div
        className="container-fluid bg-dark text-light footer pt-5 mt-5 wow fadeIn"
        data-wow-delay="0.1s"
      >
        <div className="container py-5">
          <div className="row g-5">
            {/* Column 1: Logo & Mission */}
            <div className="col-lg-4 col-md-6">
              <div className="mb-3">
                <img
                  src="assets/img/AWR-logo.png"
                  alt="All World Recruiting Logo"
                  style={{
                    maxHeight: "80px",
                    width: "auto",
                    filter: "brightness(0) invert(1)",
                  }}
                />
              </div>
              <p className="mb-3" style={{ opacity: "0.8", lineHeight: "1.6" }}>
                Specializing in manpower supply and overseas recruitment for
                Gulf countries. Connecting skilled Pakistani talent with
                international opportunities.
              </p>

              <div className="d-flex pt-2">
                <a
                  className="btn btn-outline-light btn-social me-2"
                  href="https://www.facebook.com/p/All-World-Recruiting-Overseas-Employment-Agency-61556963541768/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-facebook-f" />
                </a>
                <a
                  className="btn btn-outline-light btn-social"
                  href="https://wa.me/923214226147"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-whatsapp" />
                </a>
              </div>
            </div>

            {/* Column 2: Navigation Links */}
            <div className="col-lg-4 col-md-6">
              <h4 className="text-white mb-4">Quick Links</h4>
              <div className="d-flex flex-column justify-content-start">
                <Link className="text-light mb-2 text-decoration-none" to="/">
                  <i className="fa fa-angle-right me-2" />
                  Home
                </Link>
                <Link
                  className="text-light mb-2 text-decoration-none"
                  to="/About"
                >
                  <i className="fa fa-angle-right me-2" />
                  About Us
                </Link>
                <Link
                  className="text-light mb-2 text-decoration-none"
                  to="/Services"
                >
                  <i className="fa fa-angle-right me-2" />
                  Services
                </Link>
                <Link
                  className="text-light mb-2 text-decoration-none"
                  to="/Contact"
                >
                  <i className="fa fa-angle-right me-2" />
                  Contact Us
                </Link>
              </div>
            </div>

            {/* Column 3: Contact Details */}
            <div className="col-lg-4 col-md-6">
              <h4 className="text-white mb-4">Contact</h4>
              <p className="mb-3">
                <i className="fa fa-map-marker-alt me-3 text-primary" />
                28-B, 1st Floor, Empress House, Lahore
              </p>
              <p className="mb-3">
                <i className="fa fa-phone-alt me-3 text-primary" />
                +92 321 4226147
              </p>
              {/* PTCL Number Added Below */}
              <p className="mb-3">
                <i className="fa fa-tty me-3 text-primary" />
                042 36312010
              </p>
              <p className="mb-3">
                <i className="fa fa-envelope me-3 text-primary" />
                allworldrecruiting@gmail.com
              </p>
            </div>
          </div>
        </div>

        {/* Copyright Section */}
        <div className="container">
          <div className="copyright border-top border-primary pt-4 pb-4">
            <div className="row">
              <div className="col-md-6 text-center text-md-start mb-3 mb-md-0">
                <span style={{ opacity: "0.7" }}>
                  © {new Date().getFullYear()}{" "}
                  <Link
                    className="text-white text-decoration-none fw-bold"
                    to="/"
                  >
                    All World Recruiting
                  </Link>
                  , All Rights Reserved.
                </span>
              </div>
              <div className="col-md-6 text-center text-md-end">
                <div className="footer-menu">
                  <Link
                    to="/"
                    className="text-light text-decoration-none me-3"
                    style={{ opacity: "0.7" }}
                  >
                    Home
                  </Link>
                  <Link
                    to="/Contact"
                    className="text-light text-decoration-none me-3"
                    style={{ opacity: "0.7" }}
                  >
                    Help
                  </Link>
                  <Link
                    to="/Services"
                    className="text-light text-decoration-none"
                    style={{ opacity: "0.7" }}
                  >
                    Jobs
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Footer End */}
    </div>
  );
}
